<template>
  <div class="layout-menu-container">
    <div v-if="user.person.identifierFile" align="center">
      <hr />
      <img
        :src="$Storage.previewImg(user.person.identifierFile)"
        width="140"
        height="140"
        class="img-fluid img-thumbnail"
      />
    </div>
    <div v-else align="center">
      <img
        src="../../../public/images/sespa/brasao.svg"
        width="140"
        height="140"
        class="img-fluid img-thumbnail"
      />
    </div>
    <hr />
    <div align="center" v-if="user && user.person">
      <small>
        <b>
          {{ user.person.name }} <br />
          {{ user.person.credential }} <br />
          {{ grupo }}<br />
          {{ local.name }}<br />
        </b>
      </small>
    </div>
    <hr />
    <AppSubmenu
      :items="model"
      class="layout-menu"
      :root="true"
      @menuitem-click="onMenuItemClick"
      @keydown="onKeyDown"
    />
  </div>
</template>
  
  <script>
//COMPONENTES
import AppSubmenu from "./AppSubmenu";

//MODELS
import User from "../../models/intranet/users";

//SERVICE
import UserService from "../../service/user/user_service";
import LocalService from "../../service/local/local_service";

export default {
  props: {
    model: Array,
  },
  data() {
    return {
      userService: new UserService(),
      localService: new LocalService(),
      user: new User(),
      nome: null,
      grupo: null,
      local: [],
    };
  },
  mounted() {
    this.loadUserData();
  },
  methods: {
    onMenuItemClick(event) {
      this.$emit("menuitem-click", event);
    },
    onKeyDown(event) {
      const nodeElement = event.target;
      if (event.code === "Enter" || event.code === "Space") {
        nodeElement.click();
        event.preventDefault();
      }
    },
    loadUserData() {
      this.userService.findById(this.usuario.id).then((data) => {
        //console.log(data);
        data.group.forEach((element) => {
          if (element.service.id === 7) {
            this.grupo = element.description.replace(/_/g, " ");
          }
        });
        this.user = data;
      });
      this.local = this.$Token.getLocal();
    },
  },
  computed: {
    usuario: {
      get() {
        return this.$store.getters.getUserLogged;
      },
    },
  },

  components: {
    AppSubmenu: AppSubmenu,
  },
};
</script>